/* eslint-disable no-console */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { UPDATE_HOME_PAGE } from './HomePage.action';

export const initialState = {
    slider: {},
    productSlider: {},
    content: {},
    newLetterPopupConfig: {},
    companyCustomerData: {},
    bestSellerProductsData: {},
    isLoading: true
};

/** @namespace Pwa/Store/HomePage/Reducer/HomePageReducer */
export const HomePageReducer = (state = initialState, action) => {
    const {
        isLoading,
        type,
        slider,
        productSlider,
        content,
        newLetterPopupConfig,
        companyCustomerData,
        bestSellerProductsData
    } = action;

    switch (type) {
    case UPDATE_HOME_PAGE:
        if (slider && slider !== undefined) {
            return {
                ...state,
                isLoading,
                slider,
                productSlider,
                content,
                newLetterPopupConfig,
                companyCustomerData,
                bestSellerProductsData
            };
        }

        return {
            ...state,
            isLoading
        };

    default:
        return state;
    }
};

export default HomePageReducer;
